module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-sfix.edd63155.jpg";